import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { ScheduleMeeting } from './ScheduleMeeting';

const Wrapper = styled('div', {
  '.abyss-descriptors-error-message': {
    fontSize: '13px ',
    fontWeight: '400',
  },
});

const Title = styled('h2', {
  color: 'rgb(0, 38, 119)',
  fontSize: '25.63px !important',
  fontWeight: '700',
  minHeight: '32px',
  lineHeight: '32px',
  marginBottom: '5px',
});

export const IntegrateAPI = () => {
  const form = useForm();
  const connectToAPI = form.getValues('connectToAPI');

  return (
    <Wrapper>
      {connectToAPI === 'Yes' ? (
        <div style={{ textAlign: 'left', marginLeft: '20px' }}>
          <IconBrand
            icon="checkmark"
            style={{ marginBottom: '20px' }}
            size={100}
          />
          <Title style={{ marginBottom: '10px' }}>
            You're now ready to begin integrating with our APIs
          </Title>
          <p style={{ fontSize: '15px' }}>
            To Proceed, please complete your registration through the API
            Marketplace.
          </p>
        </div>
      ) : (
        <ScheduleMeeting />
      )}
    </Wrapper>
  );
};
